"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSessionStorageItem = exports.getSessionStorageItem = exports.setSessionStorageItem = void 0;
var isJSonString_1 = __importDefault(require("./isJSonString"));
function setSessionStorageItem(key, value) {
    try {
        if (!window || !window.sessionStorage) {
            return;
        }
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    catch (error) {
        console.error('Failed to access Session Storage', error);
    }
}
exports.setSessionStorageItem = setSessionStorageItem;
function getSessionStorageItem(key) {
    try {
        if (!window || !window.sessionStorage) {
            return null;
        }
        var value = window.sessionStorage.getItem(key) || null;
        if (value === null) {
            return null;
        }
        return (0, isJSonString_1.default)(value) ? JSON.parse(value) : value;
    }
    catch (error) {
        console.error('Failed to access Session Storage', error);
        return null;
    }
}
exports.getSessionStorageItem = getSessionStorageItem;
function removeSessionStorageItem(key) {
    try {
        if (!window || !window.sessionStorage) {
            return;
        }
        window.sessionStorage.removeItem(key);
    }
    catch (error) {
        console.error('Failed to access Session Storage', error);
    }
}
exports.removeSessionStorageItem = removeSessionStorageItem;
